var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { appEnv } from '../../env';
import NotFound from '../error/not-found';
export default function Sandbox() {
    if (appEnv.isLive)
        return _jsx(NotFound, {});
    return _jsx(Container, {});
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var templateObject_1;
